import { LazyLoad } from "./lazy-load";
export default LazyLoad;